// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inside-filters {
  margin-bottom: 36px;
}
.inside-filters .map-filters-bar {
  bottom: auto;
  top: 100%;
}

.has-callout {
  position: relative;
}

.white-bg {
  background: #fff;
  border-bottom: 1px solid #ebebeb;
}

.map-filters-bar:not(:empty) {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}
.track-wrapper .map-filters-bar:not(:empty), .with-timeline .map-filters-bar:not(:empty) {
  bottom: 205px;
  z-index: 444;
  padding: 5px;
}
.map-filters-bar:not(:empty) a {
  color: currentColor;
}
.map-filters-bar:not(:empty) .inner-map-filter-bar {
  background-clip: padding-box;
  position: relative;
}
.map-filters-bar:not(:empty) .filter-actions-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.map-filters-bar:not(:empty) .filter-actions-list > li {
  float: left;
  vertical-align: top;
}
.map-filters-bar:not(:empty) .filter-actions-list > li > a {
  display: block;
  padding: 7px 10px 6px;
  color: inherit;
  transition: all 0.4s ease;
  height: 40px;
}
.map-filters-bar:not(:empty) .filter-actions-list > li .material-icons {
  font-size: 20px;
}
.map-filters-bar:not(:empty) .map-address-search {
  width: 250px;
  padding: 4px;
  color: rgb(0, 167.5, 105.0129533679);
}
.map-filters-bar:not(:empty) .map-address-search input {
  background: none;
  color: #000;
  border-color: rgb(0, 167.5, 105.0129533679);
}
.map-filters-bar:not(:empty) .map-address-search .form-control::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.map-filters-bar:not(:empty) .map-address-search .form-control:-ms-input-placeholder {
  color: #999;
}
.map-filters-bar:not(:empty) .map-address-search .form-control::-webkit-input-placeholder {
  color: #999;
}
.map-filters-bar:not(:empty) .map-address-search .btn {
  background: none;
  border-color: rgb(0, 167.5, 105.0129533679);
  color: currentColor;
  border-left: 0;
}
.map-filters-bar:not(:empty) .map-address-search .form-control::-moz-placeholder {
  color: #fff;
  opacity: 0.5;
}
.map-filters-bar:not(:empty) .map-address-search .form-control:-ms-input-placeholder {
  color: #fff;
}
.map-filters-bar:not(:empty) .map-address-search .form-control::-webkit-input-placeholder {
  color: #fff;
}

.map-filters-wrapper:not(.no-bg) {
  position: absolute;
  left: 306px;
  text-align: center;
  top: 48px;
  bottom: -1px;
  z-index: 9999;
  width: 72px;
  overflow: auto;
  padding-bottom: 65px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
}
.track-wrapper .map-filters-wrapper:not(.no-bg), .with-timeline .map-filters-wrapper:not(.no-bg) {
  text-align: right;
  right: 16px;
  bottom: 16px;
}

.setting-filter-menu {
  display: flex;
  height: 60px;
  align-items: center;
  justify-content: center;
  left: 306px;
  bottom: 0;
  z-index: 99;
  width: 72px;
  position: fixed;
  bottom: 25px;
}

.map-filter-draggable {
  cursor: move;
  background: #fff;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
  padding-right: 5px;
  width: 40px;
  margin-left: -8px;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
}

.map-filter-draggable,
.map-filters-bar,
.map-filters-bar-vertical {
  vertical-align: top;
}

.action-heading {
  border-top: 2px solid;
  display: flex;
  font-family: "Bebas Neue", sans-serif;
  align-items: center;
  justify-content: center;
  height: 36px;
  font-size: 20px;
}

.map-filters-bar-vertical {
  height: 100%;
  padding: 0 5px;
  z-index: 1;
  position: relative;
}
.map-filters-bar-vertical .filter-actions-list li {
  display: block;
}
.map-filters-bar-vertical .rel-icons {
  vertical-align: middle;
  display: inline-block;
}
.map-filters-bar-vertical .rel-icons svg {
  width: 21px;
  height: 21px;
}
.map-filters-bar-vertical .lowBattery svg {
  margin-top: 6px;
  margin-bottom: -6px;
}
.map-filters-bar-vertical .has-menu a {
  position: relative;
}
.map-filters-bar-vertical .checkbox {
  font-size: 12px;
}
.map-filters-bar-vertical :hover > .checkbox input + span {
  color: #fff;
}
.map-filters-bar-vertical .unit-name {
  display: inline-block;
}
.map-filters-bar-vertical .filter-actions-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}
.map-filters-bar-vertical .filter-actions-list li ~ li {
  margin-top: 5px;
}
.map-filters-bar-vertical .filter-actions-list li svg {
  display: block;
}
.map-filters-bar-vertical .filter-actions-list li > a {
  color: inherit;
  padding: 5px;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 4px;
  border-radius: 6px;
}
.map-filters-bar-vertical .filter-actions-list li:last-child > a {
  border-bottom: 0;
}
.map-filters-bar-vertical .map-address-search {
  width: 250px;
  padding: 4px;
}

.counter {
  display: block;
  min-width: 1.3em;
  height: 1.3em;
  line-height: 1.3em;
  text-align: center;
  padding-left: 3px;
  padding-right: 3px;
  box-sizing: border-box;
}

.toggle-vertical-filters {
  cursor: pointer;
}

@media (max-width: 499px) {
  .map-styles-pagination {
    display: none;
  }
  .inside-filters {
    height: 100%;
    margin: 0;
  }
  .map-filters-bar-vertical {
    box-shadow: none;
    border-left: 1px solid rgba(0, 0, 0, 0.05);
    background-clip: padding-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Maps/MapFilters.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACC,mBCsBkB;ADvBnB;AAGC;EACC,YAAA;EACA,SAAA;AADF;;AAKA;EACC,kBAAA;AAFD;;AAKA;EACC,gBAAA;EACA,gCAAA;AAFD;;AAKA;EACC,uCAAA;AAFD;AAGC;EAIC,aAAA;EACA,YAAA;EACA,YAAA;AAJF;AAMC;EACC,mBAAA;AAJF;AAOC;EAEC,4BAAA;EACA,kBAAA;AANF;AASC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AAPF;AAQE;EACC,WAAA;EACA,mBAAA;AANH;AAUG;EACC,cAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AARJ;AAWG;EACC,eAAA;AATJ;AAcC;EACC,YAAA;EACA,YAAA;EACA,oCAAA;AAZF;AAcE;EACC,gBAAA;EACA,WAAA;EACA,2CAAA;AAZH;AAeE;EACC,WAAA;EACA,UAAA;AAbH;AAgBE;EACC,WAAA;AAdH;AAiBE;EACC,WAAA;AAfH;AAkBE;EACC,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;AAhBH;AAmBE;EACC,WAAA;EACA,YAAA;AAjBH;AAoBE;EACC,WAAA;AAlBH;AAqBE;EACC,WAAA;AAnBH;;AA0BA;EACC,kBAAA;EACA,WChGe;EDiGf,kBAAA;EACA,SC7Fc;ED8Fd,YAAA;EACA,aAAA;EACA,WCtGgB;EDuGhB,cAAA;EACA,oBAAA;EACA,yHAAA;AAvBD;AAyBC;EAEC,iBAAA;EACA,WAAA;EACA,YAAA;AAxBF;;AA4BA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,WCvHe;EDwHf,SAAA;EACA,WAAA;EACA,WC3HgB;ED4HhB,eAAA;EACA,YAAA;AAzBD;;AA4BA;EACC,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,yHAAA;AAzBD;;AA4BA;;;EAGC,mBAAA;AAzBD;;AA4BA;EACC,qBAAA;EACA,aAAA;EACA,qCCxEe;EDyEf,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;AAzBD;;AA4BA;EACC,YAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AAzBD;AA4BE;EACC,cAAA;AA1BH;AA8BC;EACC,sBAAA;EACA,qBAAA;AA5BF;AA6BE;EACC,WAAA;EACA,YAAA;AA3BH;AAgCE;EACC,eAAA;EACA,mBAAA;AA9BH;AAkCC;EACC,kBAAA;AAhCF;AAoCC;EACC,eC/Ha;AD6Ff;AAsCE;EACC,WAAA;AApCH;AAwCC;EACC,qBAAA;AAtCF;AAyCC;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,eCjJa;EDkJb,iBAAA;AAvCF;AA2CG;EACC,eAAA;AAzCJ;AA2CG;EACC,cAAA;AAzCJ;AA4CG;EACC,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA1CJ;AA8DI;EACC,gBAAA;AA5DL;AAmEC;EACC,YAAA;EACA,YAAA;AAjEF;;AAqEA;EACC,cAAA;EAKA,gBAAA;EACA,aAAA;EACA,kBAAA;EAEA,kBAAA;EAGA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAzED;;AA4EA;EACC,eAAA;AAzED;;AA6EA;EACC;IACC,aAAA;EA1EA;EA6ED;IACC,YAAA;IACA,SAAA;EA3EA;EA8ED;IACC,gBAAA;IACA,0CAAA;IACA,4BAAA;EA5EA;AACF","sourcesContent":["@import './../../assets/variables';\n\n.inside-filters {\n\tmargin-bottom: $mapFiltersHeight;\n\n\t.map-filters-bar {\n\t\tbottom: auto;\n\t\ttop: 100%\n\t}\n}\n\n.has-callout {\n\tposition: relative;\n}\n\n.white-bg {\n\tbackground: #fff;\n\tborder-bottom: 1px solid #ebebeb;\n}\n\n.map-filters-bar:not(:empty) {\n\tbox-shadow: 0 0 5px rgba(black, 0.25);\n\t.track-wrapper &,\n\t.with-timeline & {\n\t// \tmargin-left: 0;\n\t// \tpadding-left: 0;\n\t\tbottom: 205px;\n\t\tz-index: 444;\n\t\tpadding: 5px;\n\t}\n\ta {\n\t\tcolor: currentColor;\n\t}\n\n\t.inner-map-filter-bar {\n\t\t//box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);\n\t\tbackground-clip: padding-box;\n\t\tposition: relative;\n\t}\n\n\t.filter-actions-list {\n\t\tlist-style: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\t>li {\n\t\t\tfloat: left;\n\t\t\tvertical-align: top;\n\t\t}\n\n\t\t>li {\n\t\t\t>a {\n\t\t\t\tdisplay: block;\n\t\t\t\tpadding: 7px 10px 6px;\n\t\t\t\tcolor: inherit;\n\t\t\t\ttransition: all 0.4s ease;\n\t\t\t\theight: 40px;\n\t\t\t}\n\n\t\t\t.material-icons {\n\t\t\t\tfont-size: 20px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.map-address-search {\n\t\twidth: 250px;\n\t\tpadding: 4px;\n\t\tcolor: darken($themeColor, 5%);\n\n\t\tinput {\n\t\t\tbackground: none;\n\t\t\tcolor: #000;\n\t\t\tborder-color: darken($themeColor, 5%);\n\t\t}\n\n\t\t.form-control::-moz-placeholder {\n\t\t\tcolor: #999;\n\t\t\topacity: 1;\n\t\t}\n\n\t\t.form-control:-ms-input-placeholder {\n\t\t\tcolor: #999;\n\t\t}\n\n\t\t.form-control::-webkit-input-placeholder {\n\t\t\tcolor: #999;\n\t\t}\n\n\t\t.btn {\n\t\t\tbackground: none;\n\t\t\tborder-color: darken($themeColor, 5%);\n\t\t\tcolor: currentColor;\n\t\t\tborder-left: 0;\n\t\t}\n\n\t\t.form-control::-moz-placeholder {\n\t\t\tcolor: #fff;\n\t\t\topacity: 0.5;\n\t\t}\n\n\t\t.form-control:-ms-input-placeholder {\n\t\t\tcolor: #fff;\n\t\t}\n\n\t\t.form-control::-webkit-input-placeholder {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\n}\n\n.map-filters-wrapper:not(.no-bg) {\n\tposition: absolute;\n\tleft: $sidebarWidth;\n\ttext-align: center;\n\ttop: $headerHeight;\n\tbottom: -1px;\n\tz-index: 9999;\n\twidth: $filterColWidth;\n\toverflow: auto;\n\tpadding-bottom: 65px;\n\tbox-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n\n\t.track-wrapper &,\n\t.with-timeline & {\n\t\ttext-align: right;\n\t\tright: 16px;\n\t\tbottom: 16px;\n\t}\n}\n\n.setting-filter-menu {\n\tdisplay: flex;\n\theight: 60px;\n\talign-items: center;\n\tjustify-content: center;\n\tleft: $sidebarWidth;\n\tbottom: 0;\n\tz-index: 99;\n\twidth: $filterColWidth;\n\tposition: fixed;\n\tbottom: 25px;\n}\n\n.map-filter-draggable {\n\tcursor: move;\n\tbackground: #fff;\n\theight: 40px;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding-right: 5px;\n\twidth: 40px;\n\tmargin-left: -8px;\n\tbox-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n}\n\n.map-filter-draggable,\n.map-filters-bar,\n.map-filters-bar-vertical {\n\tvertical-align: top;\n}\n\n.action-heading {\n\tborder-top: 2px solid;\n\tdisplay: flex;\n\tfont-family: $altFontFamily;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 36px;\n\tfont-size: 20px;\n}\n\n.map-filters-bar-vertical {\n\theight: 100%;\n\tpadding: 0 5px;\n\tz-index: 1;\n\tposition: relative;\n\n\t.filter-actions-list {\n\t\tli {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t.rel-icons {\n\t\tvertical-align: middle;\n\t\tdisplay: inline-block;\n\t\tsvg {\n\t\t\twidth: 21px;\n\t\t\theight: 21px;\n\t\t}\n\t}\n\n\t.lowBattery {\n\t\tsvg {\n\t\t\tmargin-top: 6px;\n\t\t\tmargin-bottom: -6px;\n\t\t}\n\t}\n\n\t.has-menu a {\n\t\tposition: relative;\n\n\t}\n\n\t.checkbox {\n\t\tfont-size: $baseFontSize;\n\t}\n\n\t:hover {\n\t\t>.checkbox input+span {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t.unit-name {\n\t\tdisplay: inline-block;\n\t}\n\n\t.filter-actions-list {\n\t\tlist-style: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tborder-radius: 4px;\n\t\tfont-size: $baseFontSize;\n\t\tfont-weight: bold;\n\n\n\t\tli {\n\t\t\t~li {\n\t\t\t\tmargin-top: 5px;\n\t\t\t}\n\t\t\tsvg {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t>a {\n\t\t\t\tcolor: inherit;\n\t\t\t\tpadding: 5px;\n\t\t\t\tdisplay: flex;\n\t\t\t\tposition: relative;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\trow-gap: 4px;\n\t\t\t\tborder-radius: 6px;\n\t\t\t}\n\n\t\t\t>.danger .counter {\n\t\t\t\t// background-color: #dc3545;\n\t\t\t}\n\n\t\t\t>.info .counter {\n\t\t\t\t// background-color: #1976d2;\n\t\t\t}\n\n\t\t\t>.warning .counter {\n\t\t\t\t// background-color: #ffc107;\n\t\t\t}\n\n\t\t\t>.success .counter {\n\t\t\t\t// background-color: #28a745;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\t>a {\n\t\t\t\t\tborder-bottom: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\t}\n\n\t.map-address-search {\n\t\twidth: 250px;\n\t\tpadding: 4px;\n\t}\n}\n\n.counter {\n\tdisplay: block;\n\t// position: absolute;\n\t//background: $themeColor;\n\t//color: #fff;\n\t// background-color: #1976d2;\n\tmin-width: 1.3em;\n\theight: 1.3em;\n\tline-height: 1.3em;\n\t// border-radius: 50px;\n\ttext-align: center;\n\t// left: 0.3em;\n\t// top: 2px;\n\tpadding-left: 3px;\n\tpadding-right: 3px;\n\tbox-sizing: border-box;\n}\n\n.toggle-vertical-filters {\n\tcursor: pointer\n}\n\n// responsive \n@media (max-width: 499px) {\n\t.map-styles-pagination {\n\t\tdisplay: none;\n\t}\n\n\t.inside-filters {\n\t\theight: 100%;\n\t\tmargin: 0;\n\t}\n\n\t.map-filters-bar-vertical {\n\t\tbox-shadow: none;\n\t\tborder-left: 1px solid rgba(0, 0, 0, 0.05);\n\t\tbackground-clip: padding-box\n\t}\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
